import { foreignKey, pgTable, text, unique, uuid } from 'drizzle-orm/pg-core';
import { orgTableBase, orgPrimaryKey } from './org-id';
import { Block, Profile, Team } from '../schema';
import { relations } from 'drizzle-orm';
import { isoTimestamp, sortOrder } from '../utils';
export const Track = pgTable('track', {
    ...orgTableBase,
    name: text('name').notNull(),
    teamId: uuid('team_id').notNull(),
    deletedAt: isoTimestamp('deleted_at'),
    archivedAt: isoTimestamp('archived_at'),
    // zero means no sorting has been applied
    sortOrder: sortOrder.default(0),
    parentTrackId: uuid('parent_track_id'),
    color: text('color'),
}, (table) => ({
    pk: orgPrimaryKey(table),
    teamFk: foreignKey({
        columns: [table.orgId, table.teamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    // used for subtracks
    parentTrackFk: foreignKey({
        columns: [table.orgId, table.parentTrackId],
        foreignColumns: [table.orgId, table.id],
    }),
}));
export const Track_Relations = relations(Track, ({ many, one }) => ({
    athletes: many(TrackAthlete),
    blocks: many(Block),
    team: one(Team, {
        references: [Team.orgId, Team.id],
        fields: [Track.orgId, Track.teamId],
    }),
}));
export const TrackAthlete = pgTable('track_athlete', {
    ...orgTableBase,
    profileId: uuid('profile_id').notNull(),
    trackId: uuid('track_id').notNull(),
    deletedAt: isoTimestamp('deleted_at'),
}, (table) => ({
    pk: orgPrimaryKey(table),
    uq: unique().on(table.orgId, table.profileId, table.trackId),
    trackFk: foreignKey({
        columns: [table.orgId, table.trackId],
        foreignColumns: [Track.orgId, Track.id],
    }),
    profileFk: foreignKey({
        columns: [table.orgId, table.profileId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
}));
export const TrackAthlete_Relations = relations(TrackAthlete, ({ one }) => ({
    track: one(Track, {
        references: [Track.orgId, Track.id],
        fields: [TrackAthlete.orgId, TrackAthlete.trackId],
    }),
    // Inverse of Profile_Relations.trackAthletes (SC-5674's roster page
    // query) — drizzle-zero requires the One side for any Many it walks.
    profile: one(Profile, {
        references: [Profile.orgId, Profile.id],
        fields: [TrackAthlete.orgId, TrackAthlete.profileId],
    }),
}));
//# sourceMappingURL=annual-planner.js.map